import React from 'react'

const ConnectTheWorld = () => {
  return (
    <div className='connect-section'>
      <img className='connect-img' src="/img/ctw.png" alt="" />
      <h1 className='connect-h1'>Connect the world 
      through excellence</h1>
    </div>
  )
}

export default ConnectTheWorld
